import { defineFcm } from '../shared/factory';

export const FCM_USE_MEMBERSHIP_DONATION_LANGUAGE = defineFcm('use_membership_donation_language')
	.asBoolean()
	.withDefault(false)
	.toConfig();
